import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCommentList, getPost } from "../../features/slices/feedmanagement";
import { useSelector } from "react-redux";
import postImg from "../../assets/images/Property-1.png";
import heartPic from "../../assets/images/heart.png";
import profile from "../../assets/images/profile-1.png";
import moment from "moment";
import Dropdown from "react-bootstrap/Dropdown";
const ViewPost = ({ setUpdateState, postId }) => {
  const dispatch = useDispatch();
  const { postViewData, commentList } = useSelector((state) => state?.feed);

  useEffect(() => {
    dispatch(getPost({ postId }));
    dispatch(getCommentList({ postId }));
  }, []);
  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      showPost: false,
    }));
  };
  return (
    <div className="ModalBox">
      <div
        id="CreatePost"
        className="modal fade show"
        role="dialog"
        aria-modal="true"
        style={{ paddingRight: 22, display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a className="CloseModal" onClick={handleClose}>
                  ×
                </a>
                <h3>View Post</h3>
                {postViewData?.result?.[0]?.contentUrl &&
                  (postViewData?.result?.[0]?.contentType.startsWith(
                    "video"
                  ) ? (
                    <video
                      src={postViewData?.result?.[0]?.contentUrl}
                      autoPlay
                      controls
                      controlsList="nodownload"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                        height: "313px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <figure>
                      <img
                        src={postViewData?.result?.[0]?.contentUrl}
                        style={{
                          width: "100%",
                          marginTop: "10px",
                          height: "313px",
                          objectFit: "contain",
                        }}
                      />
                    </figure>
                  ))}
                <div className="CommentBox">
                  <aside>
                    <figure>
                      <img
                        src={
                          postViewData?.result?.[0]?.userData?.profilePic ||
                          require("../../assets/images/Avatar-1.png")
                        }
                        alt=""
                      />
                      <figcaption>
                        <h4>
                          {postViewData?.result?.[0]?.userData?.fullName}{" "}
                          <span>
                            {moment(
                              postViewData?.result?.[0]?.createdAt
                            ).fromNow()}
                          </span>
                        </h4>
                        <p>{postViewData?.result?.[0]?.text}</p>
                        {/* <a href="javascript:void(0);">Reply</a>
                                      <div class="ReplyBox">
                                          <input type="text"> <p>View 2 Reply</p>
                                      </div> */}
                      </figcaption>
                    </figure>
                    <div className="d-flex align-items-start">
                      <ul>
                        <li>
                          <a href="javascript:void(0);">
                            <img
                              src={require("../../assets/images/heart.png")}
                            />
                          </a>
                          &nbsp;{postViewData?.result?.[0]?.likeCount || 0}
                        </li>
                      </ul>
                      {/* <div className="dropdown ml-2">
                        <a
                          href="javascript:void(0);"
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="fa-solid fa-ellipsis-vertical" />
                        </a>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <a
                            className="dropdown-item"
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#DeleteComment"
                            data-dismiss="modal"
                          >
                            Delete
                          </a>
                        </div>
                      </div> */}
                    </div>
                  </aside>
                  {commentList?.result?.length > 0 &&
                    commentList?.result?.map((da) => {
                      return (
                        <aside className="Under" key={da?._id}>
                          <figure>
                            <img
                              src={
                                da?.commentedUserData?.[0]?.profilePic ||
                                profile
                              }
                              alt=""
                              style={{
                                objectFit: "contain",
                                width: "48px",
                                height: "48px",
                              }}
                            />
                            <figcaption>
                              <h4>
                                {da?.commentedUserData?.[0]?.fullName}
                                {" ,"}
                                <span>
                                  {moment(
                                    da?.commentedUserData?.[0]?.createdAt
                                  ).fromNow()}
                                </span>
                              </h4>
                              <p
                                style={{
                                  textAlign: "left",
                                }}
                              >
                                {da?.text}
                              </p>
                              {/* <a href="javascript:void(0);">Reply</a>
                                      <div class="ReplyBox">
                                          <input type="text"> <p>View 2 Reply</p>
                                      </div> */}
                            </figcaption>
                          </figure>
                          <div className="d-flex align-items-start">
                            <ul>
                              <li>
                                <a
                                  href="javascript:void(0);"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                  }}
                                >
                                  <img
                                    src={heartPic}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </a>
                                &nbsp;{da?.likeCount}
                              </li>
                            </ul>
                          </div>
                        </aside>
                      );
                    })}
                  {/* {postViewData?.result?.[0]?.comments?.map((res) => {
                    return (
                      <aside className="Under" key={res?._id}>
                        <figure>
                          <img
                            src={require("../../assets/images/Avatar-1.png")}
                            alt=""
                          />
                          <figcaption>
                            <h4>
                              {res?.commentedUserData?.[0]?.fullName}{" "}
                              <span> {moment(res?.createdAt).fromNow()}</span>
                            </h4>
                            <p
                              style={{
                                textAlign: "left",
                              }}
                            >
                              {res?.text}
                            </p>
                          </figcaption>
                        </figure>
                        <div className="d-flex align-items-start">
                          <ul>
                            <li>
                              <a href="javascript:void(0);">
                                <img
                                  src={require("../../assets/images/heart.png")}
                                />
                              </a>
                              &nbsp;0
                            </li>
                          </ul>
                          <div className="dropdown ml-2">
                            <a
                              href="javascript:void(0);"
                              id="dropdownMenuLink"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fa-solid fa-ellipsis-vertical" />
                            </a>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuLink"
                            >
                              <a
                                className="dropdown-item"
                                href="javascript:void(0);"
                                data-toggle="modal"
                                data-target="#DeleteComment"
                                data-dismiss="modal"
                              >
                                Delete
                              </a>
                            </div>
                          </div>
                        </div>
                      </aside>
                    );
                  })} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPost;
